var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarkOrangeIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.2842,
    r: 16,
    fill: "#F1B44C",
    fillOpacity: 0.25098
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 17.9508C17.8377 17.9508 19.3327 16.4558 19.3327 14.6175C19.3327 12.7792 17.8377 11.2842 15.9993 11.2842C14.161 11.2842 12.666 12.7792 12.666 14.6175C12.666 16.4558 14.161 17.9508 15.9993 17.9508ZM15.9994 12.9509C16.9185 12.9509 17.666 13.6984 17.666 14.6175C17.666 15.5367 16.9185 16.2842 15.9994 16.2842C15.0802 16.2842 14.3327 15.5367 14.3327 14.6175C14.3327 13.6984 15.0802 12.9509 15.9994 12.9509Z",
    fill: "#F1B44C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5174 24.4623C15.6624 24.5657 15.8316 24.6173 16.0007 24.6173C16.1699 24.6173 16.3391 24.5657 16.4841 24.4623C16.7374 24.2832 22.6916 19.984 22.6674 14.6174C22.6674 10.9415 19.6766 7.95068 16.0007 7.95068C12.3249 7.95068 9.33406 10.9415 9.33406 14.6132C9.30989 19.984 15.2641 24.2832 15.5174 24.4623ZM16.0007 9.61737C18.7582 9.61737 21.0007 11.8599 21.0007 14.6215C21.0182 18.3199 17.3441 21.6407 16.0007 22.7299C14.6582 21.6399 10.9832 18.3182 11.0007 14.6174C11.0007 11.8599 13.2432 9.61737 16.0007 9.61737Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkOrangeIconSvg);
export default __webpack_public_path__ + "static/media/location-mark-orange-icon-svg.04d24226.svg";
export { ForwardRef as ReactComponent };